export default "__VITE_ASSET__3XNrq3XV__"